import React, { useState } from 'react';

import { Container, FormControl, InputLabel, Paper, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    '& > h2': {
      margin: '0 0 0.5rem 0',
    },
  },
  filter: {
    padding: '1rem',

    '& > div': {
      display: 'flex',
      gap: '1rem',
    },

    '& > h4': {
      margin: '0 0 1rem 0',
    },
  },
});

export default function AdminStatisticsSalesPage() {
  const classes = useStyles();

  const [selectedDeliveryType, setSelectedDeliveryType] = useState('all');
  const [selectedSegment, setSelectedSegment] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('archived');
  const [selectedPeriodType, setSelectedPeriodType] = useState('date_to_date');
  const [selectedReferenceDate, setSelectedReferenceDate] = useState('deliveryDate');

  const handleStatusChange = (event) => setSelectedStatus(event.target.value);
  const handlePeriodTypeChange = (event) => setSelectedPeriodType(event.target.value);
  const handleDeliveryTypeChange = (event) => setSelectedDeliveryType(event.target.value);
  const handleReferenceDateChange = (event) => setSelectedReferenceDate(event.target.value);

  return (
    <Container maxWidth="xl" disableGutters={true} className={classes.root}>
      <h2>Statistiques des ventes</h2>
      <Paper className={classes.filter}>
        <h4>Filtrer les commandes :</h4>
        <div>
          <FormControl variant="outlined">
            <InputLabel>Type de livraison</InputLabel>
            <Select native value={selectedDeliveryType} label="Type de livraison" onChange={handleDeliveryTypeChange}>
              <option value="all">Tous</option>
              <option value="home">Domicile</option>
              <option value="relayPoint">Point relais</option>
              <option value="concierge">Conciergerie</option>
              <option value="entreprise">Entreprise</option>
              <option value="eco">Eco-acteur</option>
              <option value="bioculture">Drive</option>
            </Select>
          </FormControl>
          <FormControl variant="outlined">
            <InputLabel>Segment</InputLabel>
            <Select native value={selectedSegment} label="Segment">
              <option value="all">Tous</option>
            </Select>
          </FormControl>
          <FormControl variant="outlined">
            <InputLabel>Statut ADV</InputLabel>
            <Select native value={selectedStatus} label="Statut ADV" onChange={handleStatusChange}>
              <option value="input">En cours de saisie</option>
              <option value="validate">Validées</option>
              <option value="processed">Traitées</option>
              <option value="archived">Archivées</option>
              <option value="canceled">Annulées</option>
            </Select>
          </FormControl>
          <FormControl variant="outlined">
            <InputLabel>Date de référence</InputLabel>
            <Select native value={selectedReferenceDate} label="Date de référence" onChange={handleReferenceDateChange}>
              <option value="deliveryDate">Date de livraison</option>
              <option value="createdAt">Date de création</option>
            </Select>
          </FormControl>
          <FormControl variant="outlined">
            <InputLabel>Type de période</InputLabel>
            <Select native value={selectedPeriodType} label="Type de période" onChange={handlePeriodTypeChange}>
              <option value="date_to_date">Date à date</option>
              <option value="year">Année</option>
              <option value="month">Mois</option>
              <option value="week">Semaine</option>
              <option value="day">Jour</option>
            </Select>
          </FormControl>
          {/* TODO : Date picker */}
        </div>
      </Paper>
    </Container>
  );
}
